import { Box, Grid } from '@mui/material'
import { useState } from 'react'
import { FilterByColumnSettings } from '../../types'
import InputNumber from './InputNumber'

function EqualNumber({
  filterSettings,
  onChange
}: {
  filterSettings: FilterByColumnSettings
  onChange: (filterSettings: FilterByColumnSettings) => void
}) {
  const [number, setNumber] = useState(filterSettings?.filterNumberFirst)
  return (
    <Box mt={2}>
      <Grid item xs={4}>
        <InputNumber
          number={number}
          showLabel={true}
          adornment="="
          onChange={(value) => {
            setNumber(value)
            onChange({ ...filterSettings, filterNumberFirst: value })
          }}
        />
      </Grid>
    </Box>
  )
}

export default EqualNumber
